<template>
  <div>
    <button
      type="button"
      class="btn btn-primary"
      id="button-open-dialog"
      data-bs-toggle="modal"
      data-bs-target="#kt_modal_1"
      hidden
    ></button>
    <div class="modal fade" tabindex="-1" id="kt_modal_1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">เลือกไฟล์</h5>

            <div
              class="btn btn-icon btn-sm btn-active-light-primary ms-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span class="svg-icon svg-icon-2x"></span>
            </div>
          </div>

          <div class="modal-body">
            <div class="input-group row mb-3">
              <div class="custom-file col-sm-12">
                <input
                  type="file"
                  class="custom-file-input form-control"
                  id="inputGroupFile01"
                  aria-describedby="inputGroupFileAddon01"
                />
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              @click="submit"
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Import
            </button>
            <button
              @click="close"
              type="button"
              class="btn btn-light"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogImportExcel: Boolean,
  },
  data: () => ({}),
  watch: {
    dialogImportExcel(val) {
      if (val) {
        document.getElementById("button-open-dialog").click();
      }
    },
  },
  methods: {
    submit() {
      this.close();
    },
    close() {
      this.$emit("closeDialogImportExcel");
    },
  },
};
</script>
